import React from 'react';

const RotatedSection:React.FC = () => {
    return (
        <div className="fade-transition">
        <div className="rotatedSection">
            <div className="rotatedText">
                <h1 className="primary-color text-shadow">Portfolio</h1>
            </div>                        
        </div>

        </div>
    );
}

export default RotatedSection;
